import { SET_TOKEN, SET_USER_INFO, SET_AVATAR_URL, SET_IS_DEV } from "./types";
import { setUserInfo, setToken, setUserId } from "@/common/cookies";
export default {
  [SET_TOKEN](state, token) {
    setToken(token);
    state.token = token;
    try {
    } catch (err) {
      console.log("token err", err);
    }
  },

  [SET_USER_INFO](state, info) {
    console.log("set userinfo 55", info);
    if (info) {
      // this.$auth.$storage.setCookie('userInfo', info)
      state.userInfo = info;
      state.userId = info?.user_info_id;
      setUserInfo(JSON.stringify(info));
      setUserId(info?.user_info_id);
    }
  },
  SET_USER_ID(state, id) {
    state.userId = id;
    setUserId(id);
  },
  SET_USER_INFO_LOADING(state, loading) {
    state.userInfoLoading = loading;
    console.log("userInfoLoading", loading);
  },
  SET_USER_CREDITS_SUM(state, credits) {
    state.userInfo.credits_sum = credits;
  },
  [SET_AVATAR_URL](state, avatarUrl) {
    state.avatarUrl = avatarUrl || "";
  },
  SET_IS_DEV(state, isDev) {
    state.is_dev = isDev;
  },
};
